import Glide from '@glidejs/glide';

const testimonialCarousel = () => {

    const testimonialsCarousel = document.querySelectorAll('.testimonial-carousel');


    if (!testimonialsCarousel.length) {
        return;
    }

    testimonialsCarousel.forEach(el => {
        let glide = new Glide(el, {
            rewind: false
        }).mount();
    });
}

export default testimonialCarousel;

